// extracted by mini-css-extract-plugin
export default {"link":"UB-z","disabled":"VB-z"};